import Backbone from 'backbone';
import { renderSections, getSectionInnerHTML } from '@/lib/renderSections';
import { PUB_SUB_EVENTS, subscribe, publish } from '@/lib/pubsub';
import OneMarketing from '@/modules/module-oneMarketing';

const OneCartView = Backbone.View.extend({

    initialize: function (settings) {
        subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.handleCartUpdate.bind(this)
        );

        if (ORW.GWP && ORW.GWP.enable == `true`) {
            window.addEventListener("gwp_gift_added", this.handleCartUpdate.bind(this))
            window.addEventListener("gwp_gift_removed", this.handleCartUpdate.bind(this))
            window.addEventListener("gwp_gift_updated", this.handleCartUpdate.bind(this))
            window.addEventListener("gwp_gift_swap_updated", this.handleCartUpdate.bind(this))
        }

        if (ORW.SP && ORW.SP.enable == `true`) {
            window.addEventListener("sp_added", this.handleCartUpdate.bind(this))
            window.addEventListener("sp_removed", this.handleCartUpdate.bind(this))
            window.addEventListener("sp_updated", this.handleCartUpdate.bind(this))
        }

        if (ORW.enableGTM) {
            ORW.marketing = ORW.marketing || new OneMarketing;
            ORW.marketing.initCartPageWatchers();
        }
    },

    events: {
        'click .item-remove': 'handleRemoveItem',
        'change .item-quantity input': 'handleQuantityChange',
        'click .item-quantity button': 'handleQuantityButtonClick',
    },

    /**
     * Request updated cart HTML from Shopify Section Rendering API and replace the
     * current cart HTML with the new HTML
     */
    handleCartUpdate: async function() {
        const res = await renderSections(['cart']);

        const cartItemsHTML = getSectionInnerHTML(res.cart, '.cart-items');
        this.el.querySelector('.cart-items').innerHTML = cartItemsHTML;

        const subtotalHTML = getSectionInnerHTML(res.cart, '.total');
        this.el.querySelector('.total').innerHTML = subtotalHTML;

        const countHtml = getSectionInnerHTML(res.cart, '.cart-items-size');
        document.querySelectorAll('.minicart-count').forEach(el => {
            el.innerHTML = countHtml;
        });

        this.updateProgressBar(res);

        if (this.error) {
            const { id, message } = this.error;
            this.showError(id, message);;
        }
    },

    updateProgressBar: async function(res) {
        if (!res) return;
        const progressBarPercentage = getSectionInnerHTML(res.cart, '.progress-bar-percentage');
        const progressBarMessage = getSectionInnerHTML(res.cart, '.progress-bar-message');
        const progressBar = this.el.querySelector('.progress-bar');
    
        this.el.querySelector('.progress-bar-message').innerHTML = progressBarMessage;

        setTimeout(() => {
            progressBar.style.transition = 'width 1.2s';
            progressBar.style.width = `${progressBarPercentage}%`;
        }, 0);
    },

    /**
     * Handle click events on "remove item" buttons
     * @param {Event} e A click event
     */
    handleRemoveItem: async function(e) {
        e.preventDefault();       
        // DD-2596 Check if the clicked item is a GWP product and prevent auto re-addition 
        const targetEl = e.target
        if(targetEl.hasAttribute('data-gwp-product')){
           sessionStorage.setItem('disallow_auto_gwp_add',"true") 
        }
        const cartItemElem = e.currentTarget.closest('.cart-item');
        this.updateQuantity(cartItemElem.dataset.id, 0);
        if (ORW.enableGTM) {
            ORW.marketing.removeFromCartPage(e.currentTarget);
        }
    },

    /**
     * Start timer to send update request and reset timer if another change event
     * occurs before the timer is up
     * @param {Event} e A change event
     */
    handleQuantityChange: function(e) {
        if (this.timeout) clearTimeout(this.timeout)
        if (ORW.enableGTM) {
            console.log('handleQuantityChange ORW.enableGTM');
            ORW.marketing.checkItemQtyChangeCartPage(e.currentTarget);
        }
        const onTimeout = _ => {
            this.updateQuantity(e.currentTarget.dataset.id, e.currentTarget.value);
        };
        this.timeout = setTimeout(onTimeout.bind(this), 1000);
    },

    /**
     * Request to update cart item quantity and update relevant info
     * @param {String} id The cart item's variant ID
     * @param {Number} quantity The cart item's new quantity
     */
    updateQuantity: async function(id, quantity) {
        this.setLoading(id);
        const res = await fetch(ORW.routes.cartChangeURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: `application/json`
            },
            body: JSON.stringify({ id, quantity }),
        });
        publish(PUB_SUB_EVENTS.cartUpdate, {});
        const cart = await res.json();
        if (cart.errors) {
            this.error = {
                id,
                message: cart.errors.trim()
            };
        };
    },

    /**
     * Update the quantity input value based on the button clicked and dispatch a
     * change event
     * @param {Event} e A click event
     */
    handleQuantityButtonClick: function(e) {
        const input = e.currentTarget.closest('.item-quantity').querySelector('input');
        e.currentTarget.name === 'plus' ? input.stepUp() : input.stepDown();
        input.dispatchEvent(new Event('change', { bubbles: true }));
    },

    /**
     * Hide prices and show loading spinner for a cart item and the cart subtotal
     * @param {String} id The line item ID of the cart item
     */
    setLoading: function(id) {
        const subtotal = this.el.querySelector('.total-price');
        subtotal.querySelector('span').style.display = 'none';
        subtotal.querySelector('.spinner').style.display = 'block';

        const item = this.el.querySelector(`[data-id="${id}"]`);
        const itemTotals = item.querySelectorAll('.item-total span');
        itemTotals.forEach(span => {
            span.style.display = 'none';
        });
        item.querySelector('.item-total .spinner').style.display = 'block';
    },

    showError: function(id, message) {
        const item = this.el.querySelector(`[data-id="${id}"]`);
        const error = item.querySelector('.item-error');
        console.log(error, message)
        error.textContent = message;
    },

    destroy: function() {
        this.unsubscribe();
    }
});

export default OneCartView;